(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-tab-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tabs')) {
    customElements.define(
      'product-tabs',
      class ProductTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = this.querySelectorAll('[role="tab"]');
          this.panels = this.querySelectorAll('[role="tabpanel"]');

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => this.switchTab(e.currentTarget));
          });
        }

        switchTab(selectedTab) {
          const targetId = selectedTab.getAttribute('aria-controls');

          this.tabs.forEach((tab) => {
            const isSelected = tab === selectedTab;
            tab.setAttribute('aria-selected', isSelected);
            tab.classList.toggle('is-active', isSelected);
          });

          this.panels.forEach((panel) => {
            const isTarget = panel.id === targetId;
            if (isTarget) {
              panel.classList.remove('hidden');
              panel.classList.add('is-active');
            } else {
              panel.classList.add('hidden');
              panel.classList.remove('is-active');
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
